@if (isTileLayout()) {
    <st-pager
        pageSize="6"
        [totalCount]="totalGroupCount()"
        (startIndexChange)="onStartIndexChange($event)" />
}
